import React, { useEffect, useState } from 'react';
import { Offcanvas, Accordion } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EmptyCart from "../../assets/images/emptyCart.png";
import _ from 'lodash';
import { useDispatch } from "react-redux";
import { addToCart } from '../../store/actions';
import AlertDialogModal from './AlertDialog';
import PropTypes from 'prop-types';

const SidebarShipment = ({ closeDrawer, show, options, setShow }) => {
    const navigate = useNavigate();
    const { cartItems } = useSelector((state) => state.shipment);
    const [cartItemListing, setCartItemListing] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [showAlert, setShowAlert] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        setCartItemListing(cartItems);
    }, [cartItems]);

    /**
     * Ship now button click
     */
    const handleShipNow = () => {
        closeDrawer();
        setTimeout(() => {
            navigate('/shipment');
        }, 100); // Delay navigation slightly
    };

    /**
     * Remove item from cart
     */
    const handleRemoveItem = () => {
        let items = _.cloneDeep(cartItems);
        let index = items.findIndex(listItem => listItem.id === selectedItem.id);
        if (index > -1) {
            items.splice(index, 1);
        }
        setShowAlert(false);
        setSelectedItem({});
        dispatch(addToCart(items));
    }

    /**
     * @param {Object} item 
     */
    const handleAddQuantity = (item) => {
        let items = _.cloneDeep(cartItems);
        let index = items.findIndex(listItem => listItem.id === item.id);
        items[index].quantity = items[index].quantity + 1;
        dispatch(addToCart(items));
    };

    /**
     * @param {Object} item 
     */
    const handleRemoveQuantity = (item) => {
        let items = _.cloneDeep(cartItems);
        let index = items.findIndex(listItem => listItem.id === item.id);
        items[index].quantity = items[index].quantity - 1;
        dispatch(addToCart(items));
    };

    /**
     * @param {Object} item 
     */
    const handleDeleteItem = (item) => {
        setShowAlert(true);
        setSelectedItem(item);
    };

    return (
        <>
            <Offcanvas align={'end'} onHide={closeDrawer} show={show} options={options}>
                <div className='modalDeleteWrapper'>
                    <Offcanvas.Header closeButton />
                    <Offcanvas.Title className='main__tile_heading'>Item(s) Details 
                        <div className='modalActions alignRight pr-0 mt-3'>
                            {cartItemListing.length > 0 && <button className='btn cus-seconday-bg-btn' onClick={handleShipNow}>Ship Now</button>}
                        </div>
                    </Offcanvas.Title>
                    <Offcanvas.Body className='shipmentDrawer incomingAccordion accordion mt-3'>
                        {cartItemListing.length > 0 && (
                            <Accordion
                                alwaysOpen={true}
                                defaultActiveKey={[0]}
                                style={{ minHeight: '70vh' }}
                            >
                                {cartItemListing.length > 0 && cartItemListing.map((item, index) => (
                                    <Accordion.Item eventKey={index} key={item.id}>
                                        <Accordion.Header>
                                            {item.itemName}
                                            <span> <span className='fontFix mr-2'></span>  <i className="fa fa-chevron-down" aria-hidden="true"></i></span>
                                        </Accordion.Header>
                                        <Accordion.Body >
                                            <div className="row addressForm fontFix">
                                                <div className="col-lg-2 col-md-6 col-sm-12 zIndex2">
                                                    <div>Thumb</div>
                                                    <div className='listValue'>
                                                        <img src={item.thumbnailUrl} alt="product" style={{ maxHeight: '40px' }} />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12 zIndex2">
                                                    <div>
                                                        Product SKU
                                                    </div>
                                                    <div className='listValue'>{item.sku}</div>
                                                </div>
                                                <div className="col-lg-2 col-md-6 col-sm-12 zIndex2">
                                                    <div>Qty</div>
                                                    <div className='quantityDetails'>
                                                        <div className=''>
                                                            {item.quantity === 1 && <i className={`fa fa-trash cursorPointer`} aria-hidden="true" onClick={() => handleDeleteItem(item)}></i>}
                                                            {item.quantity > 1 && <i className={`fa fa-minus cursorPointer`} aria-hidden="true" onClick={() => handleRemoveQuantity(item)}></i>}
                                                        </div>
                                                        <div className=''>{item.quantity}</div>
                                                        <div className=''>
                                                            <i className={`fa fa-plus cursorPointer ${item.quantity === item.MaxQuantity ? 'disableIcon' : 'test'}`} aria-hidden="true" onClick={() => handleAddQuantity(item)}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-md-6 col-sm-12 zIndex2">
                                                    <div style={{ height: '20px' }}></div>
                                                    <i className="fa fa-trash require-field deleteBtnDrawer View-Icon" aria-hidden="true" onClick={() => handleDeleteItem(item)}></i>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        )}
                        {cartItemListing.length === 0 && <div className='noRecordFound alignCenter cartEmpty'>
                            <img src={EmptyCart} alt='' style={{ maxWidth: '400px', opacity: 0.5 }} />
                        </div>}
                    </Offcanvas.Body>
                </div>
                
            </Offcanvas>
            {showAlert && (
                <AlertDialogModal
                    modalShow={showAlert}
                    handleCancelDeleteAlert={() => setShowAlert(false)}
                    modalClass={"modalDeleteWrapper"}
                    messageText="Are you sure, you want to remove this item from cart?"
                    handleYesDeleteAlert={handleRemoveItem}
                    headingText={"UPDATE STATUS"}
                />
            )}
        </>
    );
}

SidebarShipment.propTypes = {
    closeDrawer: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    options: PropTypes.any,
    setShow: PropTypes.func
};

export default SidebarShipment;